class FreeShippingByProductId {
  constructor() {
    // Enter the variant ids you want free shipping for in this list.
    this.specificProductIds = [55021850657148];
    // You need to create the discount code in the admin first, activate it and paste it here.
    this.discountCode = 'FREE GSB SHIPPING';
  }

  init() {
    this.monitorFreeShippingProducts().then(() => {
      this.observeCartChanges();
    });
  }

  async monitorFreeShippingProducts() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const hasEligibleProduct = cart.items.some(item => this.specificProductIds.includes(item.id));
   console.log(cart.items);
      if (hasEligibleProduct) {
        this.applyFreeShippingDiscount();
        
      } else {
        this.removeFreeShippingDiscount();

      }
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  async applyFreeShippingDiscount() {
    try {
      const response = await fetch(`/discount/${this.discountCode}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.ok) {
        console.log("Free Shipping discount was added.");
      } else {
        console.error("Could not add the free shipping discount:", response.statusText);
      }
    } catch (error) {
      console.error("Error while adding the free shipping discount:", error);
    }
  }
  
  async removeFreeShippingDiscount() {
    try {
      const response = await fetch(`/discount/remove/${this.discountCode}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.ok) {
        console.log("Free Shipping discount was removed.");
      } else {
        console.error("Could not remote the free shipping discount:", response.statusText);
      }
    } catch (error) {
      console.error("Error while removing the free shipping discount:", error);
    }
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.monitorFreeShippingProducts();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}


const myCartWatcher = new FreeShippingByProductId();
myCartWatcher.init();